import { ModelResource } from './resource';
import {
  type PresignedUrl,
  Remittance,
  Attachment,
  KnowledgeEntry,
  type W9Form,
  type ACHInformation,
} from '../models';

export class KnowledgeEntries extends ModelResource<KnowledgeEntry> {
  model = KnowledgeEntry;

  resourcePath = 'v1/knowledge-entries';

  async upload(
    entry_type: string,
    file_name: string,
    mime_type: string,
    presignUrlParams: Record<string, any>,
  ): Promise<{
    presignedUrl: PresignedUrl;
    knowledgeEntry: KnowledgeEntry;
    attachment: Attachment | null;
  }> {
    const response = await this.api.post(this.path('upload'), {
      data: {
        entry_type,
        file_name,
        mime_type,
        ...presignUrlParams,
      },
    });

    const { knowledge_entry, presigned_url } = response.data;
    const knowledgeEntryRecord = KnowledgeEntry.fromJson(knowledge_entry);

    return {
      knowledgeEntry: knowledgeEntryRecord,
      presignedUrl: presigned_url,
      attachment: knowledgeEntryRecord?.attachment,
    };
  }

  async confirm(
    knowledgeEntry: KnowledgeEntry,
    confirmed_data: W9Form | ACHInformation | null,
  ): Promise<KnowledgeEntry> {
    return this.api
      .post(this.path(knowledgeEntry.id, 'confirm'), {
        data: { confirmed_data: confirmed_data },
      })
      .then((res) => {
        knowledgeEntry = KnowledgeEntry.fromJson(res.data);
        return knowledgeEntry;
      });
  }
}
